import { useEffect, useState } from 'react';

// Three breakpoints
const BREAKPOINT_SMALL = 1300;
const BREAKPOINT_LARGE = 1400;

export const useResponsiveCarousel = () => {
  const [maxImages, setMaxImages] = useState(5);

  useEffect(() => {
    const updateMaxImages = () => {
      const width = window.innerWidth;

      if (width < BREAKPOINT_SMALL) {
        setMaxImages(3); // Small screens: 3 images
      } else if (width < BREAKPOINT_LARGE) {
        setMaxImages(4); // Medium screens: 4 images
      } else {
        setMaxImages(5); // Large screens: 5 images
      }
    };

    updateMaxImages();

    window.addEventListener('resize', updateMaxImages);

    return () => window.removeEventListener('resize', updateMaxImages);
  }, []);

  return maxImages;
};
